export default __webpack_public_path__ + "static/media/distanstolkning9.f931fc60.png";